module.exports = __webpack_public_path__ + "static/media/ibd_arm1.132d0646.png";